import React, { Suspense } from 'react';
import { Outlet } from 'react-router';

export const UiSuspensefulOutlet: React.FC = () => (
    <Suspense>
        <Outlet />
    </Suspense>
);
